var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 0a8 8 0 010 16A8 8 0 018 0zm0 1.6a6.4 6.4 0 10.01 12.81A6.4 6.4 0 008 1.6zm3.2 5.6a.8.8 0 01.8.8.8.8 0 01-.8.8H4.8A.8.8 0 014 8c0-.44.36-.8.8-.8h6.4z", "fill-rule": "nonzero" } }] }, name: "minus-circle", theme: "outlined" };
export {
  a as default
};
